<template>
  <div>
    <fieldset class="form__field-group">
      <div class="selectable-boxes-container" v-if="!selectedActor">
        <p>
          Vi fant flere kundeforhold knyttet til dette nummeret. Klikk en
          adresse for å velge den.
        </p>
        <div
          class="selectable-boxes-wrapper"
          :key="actor.id"
          v-for="actor in actors"
        >
          <div class="selectable-boxes" @click="selectAddress(actor)">
            {{ actor.addressLine1 }}
          </div>
        </div>
      </div>
      <div class="selectable-boxes-container" v-else>
        <div
          class="selectable-boxes-wrapper"
          :key="placeOfConsumption.id"
          v-for="placeOfConsumption in selectedActor.placesOfConsumption"
        >
          <div
            class="selectable-boxes"
            @click="selectPlaceOfConsumption(placeOfConsumption)"
          >
            {{ placeOfConsumption.address.streetName }}
            {{ placeOfConsumption.address.houseLetter
            }}{{ placeOfConsumption.address.entrance || '' }}
          </div>
        </div>
        <div v-if="!selectedActor.placesOfConsumption">
          <p class="text-red-light">Fant ingen informasjon om ditt forbruk.</p>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
import store from '../store';

export default {
  name: 'SelectPlaceOfConsumption',
  methods: {
    selectAddress(actor) {
      store.commit('smsLogin/setActorId', actor.id);
      store.dispatch('smsLogin/getActor');
    },
    selectPlaceOfConsumption(placeOfConsumption) {
      store.commit('smsLogin/setPlaceOfConsumption', placeOfConsumption);
      store.dispatch('smsLogin/setDeliveryPoint');
    },
  },
  computed: {
    actors() {
      return store.state.smsLogin.actors;
    },
    selectedActor() {
      return store.state.smsLogin.selectedActor;
    },
  },
};
</script>

<style scoped>
.selectable-boxes {
  z-index: 0;
}
</style>
